// extracted by mini-css-extract-plugin
module.exports = {"carousel":"locationCarousel-module--carousel--14fRj","carouselContainer":"locationCarousel-module--carousel-Container--2qmKO"};